<template>
    <a :class="{ full: basketStore.full }" href="/products" @click="handleClick">Your Order</a>
</template>

<script setup>
    import { useBasketStore } from './store';

    const basketStore = useBasketStore();

    const handleClick = (event) => {
        if (window.location.pathname === '/products') {
            event.preventDefault();
            const basketElement = document.getElementById('basket-overview');
            if (basketElement) {
                basketElement.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };
</script>